// extracted by mini-css-extract-plugin
export var saleImgBox = "Sale-module--saleImgBox--bprOu";
export var saleImg = "Sale-module--saleImg--BsAJ7";
export var saleInner = "Sale-module--saleInner--asJUF";